module.exports = __webpack_public_path__ + "img/nuestros-servicios_3-pasos-03contrato..8e5cdb90.svg";